import axios from '@axios'

export default {
  loadTable(queryFilter) {
    let queryUrl = ''
    queryFilter.order = 'asc'
    queryUrl = `?page=${queryFilter.page - 1}&size=${
      queryFilter.size
    }&sort=dataInicial,desc`
    if (queryFilter.filter) {
      queryUrl = `/pesquisar?${queryFilter.filter}`
    }
    return axios.get(`/atendimento/agendamentos${queryUrl}`)
  },
  insert(data) {
    return axios.post('/atendimento/agendamentos', data)
  },
  edit(data) {
    return axios.put(`/atendimento/agendamentos/${data.id}`, data)
  },
  delete(id) {
    return axios.delete(`/atendimento/agendamentos/${id}`)
  },
  getById(id) {
    return axios.get(`/atendimento/agendamentos/${id}`)
  },
  getProfissional(id) {
    return axios.get(`/atendimento/agendamentos/${id}/profissionais`)
  },
  searchProfessional(name) {
    const endpoint = `/atendimento/agendas/pesquisar_profissional?nome=${name}&page=0&size=10&sort=id,asc`
    return axios.get(endpoint)
  },
  agendasById(id) {
    return axios.get(`/atendimento/agendamentos/agenda/${id}`)
  },
  bloquearDataById(id) {
    return axios.get(`/atendimento/agendamentos/bloquear_data/${id}`)
  },
  desbloquearDataById(id) {
    return axios.get(`/atendimento/agendamentos/bloquear_data/${id}`)
  },
  carregarAtendimentos(data) {
    return axios.get(
      `atendimento/atendimentos/${data.id}/${data.data}/agendamento`,
    )
  },
  editAgenda(data) {
    return axios.put('/atendimento/agendamentos/alterar_data', data)
  },
  controleVagasEspecialidade(data) {
    return axios.post(`/atendimento/controles/${data.agendamento}`, data)
  },
  getControleQtdVagas(id) {
    return axios.get(`/atendimento/controles/agendamento/${id}`)
  },
  filtro(pageConfig, filter) {
    let queryUrl = ''
    queryUrl = `?page=${pageConfig.page - 1}&size=${pageConfig.size}&${
      pageConfig.sort
    },${pageConfig.order}`
    return axios.post(`/atendimento/agendamentos/filtro${queryUrl}`, filter)
  },
}
